import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[rtTypeaheadInput]',
  exportAs: 'rtTypeaheadInput',
  standalone: true,
})
export class TypeaheadInputDirective {
  constructor(public control: NgControl) {}
}
